<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToGridItem'
});
</script>
<template>
	<div :flex="flex ? flex : null" class="to-grid-item" :style="setStyle">
		<slot></slot>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'



export interface Props {
	width?: number | string
	flex?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	width: '',
	flex: false
})

const setStyle = computed(() => {
	const style: Record<string, string> = {}

	if (props.width) {
		if (!isNaN(Number(props.width))) {
			style.width = `${props.width}em`
		} else if (props.width === 'full') {
			style.width = '100%'
		} else {
			style.width = props.width.toString()
		}
	}

	return style
})
</script>
